import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button/button.component';
import { ButtonGroupComponent } from './button-group/button-group.component';
import { ButtonIconComponent } from './button-icon/button-icon.component';
import { SceneButtonComponent } from './scene-button/scene-button.component';
import { PinButtonComponent } from './pin-button/pin-button.component';
import { IconModule } from '../icon/icon.module';

@NgModule({
  imports: [
    CommonModule,
    IconModule
  ],
  declarations: [
    ButtonComponent,
    ButtonGroupComponent,
    ButtonIconComponent,
    SceneButtonComponent,
    PinButtonComponent
  ],
  exports: [
    ButtonComponent,
    ButtonGroupComponent,
    ButtonIconComponent,
    SceneButtonComponent,
    PinButtonComponent
  ]
})
export class ButtonsModule { }
